import type { RoutingServiceKey, VendorEndpointMapping } from '../domain/vendor';
import type { CapabilityOptionLike } from './adapterCapabilityCatalog';
import { adapterEndpointServiceName, selectableCapabilitiesForGroup } from './adapterCapabilityCatalog';

export function endpointMappingKey(
  endpoint: Pick<VendorEndpointMapping, 'serviceName' | 'capability'>,
): string {
  return `${endpoint.serviceName ?? ''}|${endpoint.capability}`;
}

export function removeEndpointMapping(
  mappings: VendorEndpointMapping[],
  target: Pick<VendorEndpointMapping, 'serviceName' | 'capability'>,
): VendorEndpointMapping[] {
  const key = endpointMappingKey(target);
  return mappings.filter(item => endpointMappingKey(item) !== key);
}

export function isServerDraftEndpoint(endpoint: VendorEndpointMapping | null | undefined): boolean {
  return endpoint?.onboardingStatus === 'draft';
}

export function endpointBelongsToServiceContext(
  endpoint: VendorEndpointMapping,
  serviceName: string,
  adapterServiceKey: string,
): boolean {
  const stored = (endpoint.serviceName ?? '').trim();
  const service = serviceName.trim();
  const adapterKey = adapterServiceKey.trim();
  return stored === service || stored === adapterKey;
}

export function findSavedEndpointMapping(
  mappings: VendorEndpointMapping[],
  capability: string,
  serviceName: string,
  adapterServiceKey: string,
): VendorEndpointMapping | undefined {
  return mappings.find(item =>
    item.capability === capability &&
    endpointBelongsToServiceContext(item, serviceName, adapterServiceKey),
  );
}

export function isCapabilityClaimed(
  mappings: VendorEndpointMapping[],
  capability: string,
  serviceName: string,
  adapterServiceKey: string,
): boolean {
  return findSavedEndpointMapping(mappings, capability, serviceName, adapterServiceKey) !== undefined;
}

export function unclaimedCapabilitiesForGroup(
  catalog: CapabilityOptionLike[],
  serviceName: RoutingServiceKey,
  groupKey: string | null,
  mappings: VendorEndpointMapping[],
): CapabilityOptionLike[] {
  return selectableCapabilitiesForGroup(catalog, serviceName, groupKey).filter(
    option =>
      !isCapabilityClaimed(
        mappings,
        option.capability,
        serviceName,
        adapterEndpointServiceName(option),
      ),
  );
}

export function canAddApiForVendorGroup(
  catalog: CapabilityOptionLike[],
  serviceName: RoutingServiceKey,
  groupKey: string | null,
  mappings: VendorEndpointMapping[],
): boolean {
  return unclaimedCapabilitiesForGroup(catalog, serviceName, groupKey, mappings).length > 0;
}
